module.exports = __webpack_public_path__ + "img/tigranpf.9934b56b.png";